﻿import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, AuthenticationService, UserService } from './_services/index'
import { environment } from '../environments/environment';
@Component({
    moduleId: module.id,
    selector: 'app-root',
    templateUrl: 'app.component.html'
})

export class AppComponent { 
  currentUser: any;
  backendUrl: any;
  navigationStatus:boolean=false;
   constructor(private translate:TranslateService,private router: Router,private userService: UserService)
   {
    this.backendUrl = environment.url;
   	 let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
   	 if(currentUser){
      let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
      if (u_locale.indexOf("_")!= -1){
          let arr=u_locale.split('_'); 
              u_locale=arr[0];                    
          }
      else{
            u_locale='en';
          }
        this.translate.setDefaultLang(u_locale);   		
      }
	}

	ngOnInit()
	{
		$(document).ready(function(){
			
    })
   
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    let url=window.location.origin
    url+="/"
    if(!environment.production)
     url = "https://stage.foodbot.ai/"

    console.log("check data hererererer",url)
    let formdata={
     "domain":url
    }
    var version = localStorage.getItem('localStorageVersion')
    this.userService.getWebVersions().subscribe((res: any) => {
      if (!version || (version != res.version)) {
        this.userService.generateAuthToken()
        localStorage.setItem('localStorageVersion', res.version)
        let data = { 'type': 'version_updated', 'version': res.version }
        console.log(JSON.stringify(data))
        window.location.href = window.location.href.replace(/#.*$/, '');
        window.location.reload();
      }
    })
    document.querySelector('title').textContent = "";
    document.getElementById('favIcon').setAttribute('href', "")
    this.userService.whitelabel_partner_check(this.backendUrl,formdata)
    .subscribe(res => {
      
        if(res.status_code==200){ 
            document.getElementById('favIcon').setAttribute('href', res.data.dashboard.settings.favicon)
            document.querySelector('title').textContent = res.data.dashboard.settings.favicon_text;
          localStorage.setItem("whiteLabelSetting",JSON.stringify(res.data))
          let settings: any = localStorage.getItem('whiteLabelSetting')
          this.userService.settingCss(settings)
          this.navigationStatus=true
        }else{
          this.navigationStatus=true
        }

      })

	}

}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/app.component.ts